export const firstChartSectionId = 'mortgage-section';
